import { Form, Icon, Modal } from 'antd';
import React from 'react';
import AlertDateForm from './AlertDateForm';
import { useDispatch, useSelector } from 'react-redux';
import useChangeAlertDate from '../../hooks/useChangeAlertDate';
import { closeModalAlertDate } from '../../../../actions/alert-date.actions';
import { requestListActions } from '../../request-list.actions';

const ModalNode = ({ form }) => {
  const dispatch = useDispatch();

  const { visible, data, isRequestForImmediate } = useSelector(
    (state) => state.alertDateStore
  );

  const { isLoading, onChange } = useChangeAlertDate();

  const isRequred = isRequestForImmediate || !!data?.isImmediate;

  const close = () => dispatch(closeModalAlertDate());

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) return;

      if (true) {
        await dispatch(
          requestListActions.setRequestMark(data?.id, 'immediate', 1)
        );
      }

      await onChange({ value: values.alertDate, id: data?.id });

      close();
    });
  };

  return (
    <Modal
      visible={visible}
      width={400}
      title="Изменить дату контроля"
      okText={isLoading ? <Icon type="loading" /> : 'Сохранить'}
      cancelText="Отмена"
      onCancel={close}
      onOk={handleSubmit}
    >
      <AlertDateForm
        form={form}
        request={data}
        isRequred={isRequred}
      />
    </Modal>
  );
};

const ModalAlertDate = Form.create({
  name: 'ModalNode',
})(ModalNode);

export default ModalAlertDate;
